import React from 'react'
import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'
import PageHeader from '@/components/Common/PageHeader'
import SEOHead from '@/components/SEO/SEOHead'
import { buildGraph, breadcrumbListData, itemListSchema } from '@/data/structured-data'
import { clinicServices } from '@/data/services'

const ClinicIndex: React.FC = () => {
  return (
    <>
      <SEOHead
        title="Kliniğimiz | Ardıç Veteriner Kliniği"
        description="Ameliyathane, muayene odaları, dijital görüntüleme, klinik laboratuvar, pet oteli ve kuaför. Şanlıurfa Karaköprü'deki kliniğimizin birimlerini tanıyın."
        keywords="klinik, hayvan kliniği, veteriner klinigi, şanlıurfa veteriner, karaköprü veteriner, röntgen, ameliyathane, laboratuvar"
        canonicalUrl="/klinik"
        structuredData={buildGraph(
          itemListSchema({
            name: 'Kliniğimiz',
            url: '/klinik',
            items: clinicServices.map(s => ({ name: s.title, url: `/klinik/${s.slug}` }))
          }),
          breadcrumbListData([
            { name: 'Ana Sayfa', url: '/' },
            { name: 'Kliniğimiz', url: '/klinik' }
          ])
        )}
      />
      <PageHeader title="Kliniğimiz" subtitle="Modern donanım ve steril ortam ile güvenilir veteriner hizmeti." />
      <section className="section-padding">
        <div className="container-custom">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {clinicServices.map((s, i) => (
              <motion.div key={s.id} initial={{opacity:0,y:10}} animate={{opacity:1,y:0}} transition={{delay:i*0.03}} className="bg-white rounded-xl border p-0 shadow hover:shadow-lg transition overflow-hidden">
                {s.image && (
                  <img src={s.image} alt={s.title} className="w-full h-40 object-cover" loading="lazy" onError={(e)=>{(e.currentTarget as HTMLImageElement).src='/klinik.webp'}} />
                )}
                <div className="p-6">
                  <h3 className="font-bold text-lg mb-2">{s.title}</h3>
                  <p className="text-gray-600 text-sm mb-4">{s.description}</p>
                  <Link to={`/klinik/${s.slug}`} className="text-primary-600 font-semibold">Detayları Gör</Link>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}

export default ClinicIndex


